export * from './types/legacy-component-types';
/**
 * @export
 */
export var ThemeType;
(function (ThemeType) {
    ThemeType["Light"] = "Light";
    ThemeType["Dark"] = "Dark";
    ThemeType["Glass"] = "Glass";
})(ThemeType || (ThemeType = {}));
export var Environment;
(function (Environment) {
    Environment["Prod"] = "prod";
    Environment["Dev"] = "dev";
})(Environment || (Environment = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["Widget"] = "widget";
    ComponentType["UI"] = "ui";
    ComponentType["Background"] = "background";
    ComponentType["Component"] = "component";
})(ComponentType || (ComponentType = {}));
// ============================================================================
// WINDOW EXTENSIONS
// ============================================================================
// Note: Window interface extensions remain in types.d.ts as ambient declarations
